<template>
  <header id="header" class="header fixed-top d-flex align-items-center">

    <div class="d-flex align-items-center justify-content-between">
      <router-link to="/" class="logo d-flex align-items-center">
        <img src="assets/img/logo.png" alt="">
        <span class="d-none d-lg-block">FinPlan</span>
      </router-link>
      <i @click="toggleSidebar" class="bi bi-list toggle-sidebar-btn"></i>
    </div>

    <nav class="header-nav ms-auto">
      <ul class="d-flex align-items-center">
        <NotificationsIcon />
        <li class="nav-item dropdown pe-3"><UserIcon /></li>
      </ul>
    </nav>

  </header>
</template>

<script setup>
import NotificationsIcon from "@/features/notifications/components/NotificationsIcon.vue";
import UserIcon from "@/features/personal/components/UserIcon.vue";

function toggleSidebar() {
  document.body.classList.toggle('toggle-sidebar');
}
</script>

<style scoped>

</style>